<template>
  <div class="dropdown" ref="dropdown">
    <div class="anchor" ref="anchor">
      <slot name="anchor" class="anchor-element" />
    </div>
    <div v-if="open" class="overlay" @click="handleOutsideClick"></div>
    <div
      v-if="open"
      :class="['dropdown-content', positionClass]"
      :style="{ ...dropdownLocation, ...dropdownStyle }"
    >
      <slot />
    </div>
  </div>
</template>
<script>
const POSITION = {
  leftBottom: 'left-bottom',
  rightBottom: 'right-bottom'
};

const DEFAULT_STYLE = {
  width: 'max-content',
  height: 'max-content'
};
export default {
  name: 'ScpmDropDown',
  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    position: {
      type: String,
      default: () => POSITION.leftBottom
    },
    width: {
      type: [String, Number],
      default: () => DEFAULT_STYLE.width
    },
    height: {
      type: [String, Number],
      default: () => DEFAULT_STYLE.height
    },
    customStyle: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      dropdownLocation: {
        left: '0px'
      }
    };
  },
  computed: {
    positionClass() {
      return `dropdown-${this.position}`;
    },
    dropdownStyle() {
      let width = this.width;
      let height = this.height;
      if (typeof this.width === 'number') width += 'px';
      if (typeof this.height === 'number') height += 'px';
      return { width, height, ...this.customStyle };
    }
  },
  watch: {
    open: {
      handler(v) {
        if (v) return this.getDropdownPosition();
      }
    }
  },
  mounted() {
    window.removeEventListener('resize', this.getDropdownPosition);
    window.addEventListener('resize', this.getDropdownPosition);
  },
  methods: {
    handleOutsideClick(event) {
      this.$emit('outside-click');
    },
    getDropdownPosition() {
      const element = this.$refs.anchor;
      if (!element) return;
      const { left } = element.getBoundingClientRect();
      this.dropdownLocation.left = left + 'px';
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  }
};
</script>
<style lang="scss" scoped>
.dropdown {
  position: relative;
  display: inline-block;
}
.anchor {
  position: relative;
}
.overlay {
  position: fixed;
  background: transparent;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 100;
}
.dropdown-content {
  position: fixed;
  box-shadow: 0px 8px 15px 2px rgba(23, 25, 28, 0.15), 0px 0px 4px 0px rgba(23, 25, 28, 0.2),
    0px -1px 4px 0px rgba(23, 25, 28, 0.15), 0px -1px 4px 0px rgba(23, 25, 28, 0.1) inset;
  background-color: #fff;
  margin-top: 10px;
  border-radius: 4px;
  z-index: 5000;
}
.dropdown-content::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  margin-left: 20px;
  top: 0%;
  left: 50%;
  box-sizing: border-box;
  border: 5px solid white;
  border-color: transparent transparent white white;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -3px 3px 3px 0 rgba(0, 0, 0, 0.2);
}
.dropdown-left-bottom {
  left: 0;
}
.dropdown-left-bottom::after {
  left: 34px;
}

.dropdown-right-bottom {
  right: 0;
}
.dropdown-right-bottom::after {
  right: 34px;
}
</style>
